import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import 'hammerjs';
import {
  MbAdvice,
  MbFormField,
  MbButton,
  MbAlert,
  MbIcon,
  MbPopoverTrigger,
  MbTooltipTrigger,
  MbStarsRating,
  MbDatepicker,
  MbExpandablePanel,
  MbCarousel,
  MbDialogBody,
  MbDialogHeader,
} from '@am/moebius';

// Modals Component
import { ModalAccommodationFeeComponent } from '@modals/acommodation-fee/accommodation-fee.component';
import { ModalChargesComponent } from '@modals/charges/charges.component';
import { ModalDisneyBenefitsComponent } from '@modals/disney-benefits/disney-benefits.component';
import { ModalDisneyClusterMealsInfoComponent } from '@modals/disney-cluster-meals-info/disney-cluster-meals-info.component';
import { ModalDisneyClusterTicketsInfoComponent } from '@modals/disney-cluster-tickets-info/disney-cluster-tickets-info.component';
import { ModalHotelIntroComponent } from '@modals/hotel-intro/hotel-intro.component';
import { ModalImageMessageComponent } from '@modals/image-message/image-message.component';
import { ModalModifySearchComponent } from '@modals/modify-search/modify-search.component';
import { ModalRoomComponent } from '@modals/room/room.component';
import { ModalUniversalBenefitsDetailComponent } from '@modals/universal-benefits-detail/universal-benefits-detail.component';
import { ModalGalleryComponent } from '@modals/gallery/gallery.component';
import { ModalUserInactivityComponent } from '@modals/user-inactivity/user-inactivity.component';
import { ModalWithFullPriceComponent } from '@modals/with-full-price/with-full-price.component';
import { ModalDisneyPurchasePolicyComponent } from '@modals/disney-purchase-policy/disney-purchase-policy.component';
import { DetailModule } from './../containers/detail/detail.module';
import { RateUnavailableComponent } from './rate-unavailable/rate-unavailable.component';
import { RateNotFoundComponent } from './rate-not-found/rate-not-found.component';
import { RatePriceChangedComponent } from './rate-price-changed/rate-price-changed.component';

const MOEBIUS_IMPORTS = [
  MbAdvice,
  MbFormField,
  MbButton,
  MbAlert,
  MbIcon,
  MbStarsRating,
  MbTooltipTrigger,
  MbDialogBody,
  MbDialogHeader,
  MbPopoverTrigger,
  MbDatepicker,
  MbExpandablePanel,
  MbCarousel,
];

@NgModule({
  imports: [
    DetailModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ...MOEBIUS_IMPORTS,
    ModalAccommodationFeeComponent,
    ModalChargesComponent,
    ModalDisneyBenefitsComponent,
    ModalDisneyClusterMealsInfoComponent,
    ModalDisneyClusterTicketsInfoComponent,
    ModalHotelIntroComponent,
    ModalImageMessageComponent,
    ModalModifySearchComponent,
    ModalRoomComponent,
    ModalUniversalBenefitsDetailComponent,
    ModalGalleryComponent,
    ModalUserInactivityComponent,
    ModalWithFullPriceComponent,
    ModalDisneyPurchasePolicyComponent,
    RateUnavailableComponent,
    RateNotFoundComponent,
    RatePriceChangedComponent,
  ],
  declarations: [],
  exports: [
    ModalAccommodationFeeComponent,
    ModalChargesComponent,
    ModalDisneyBenefitsComponent,
    ModalDisneyClusterMealsInfoComponent,
    ModalDisneyClusterTicketsInfoComponent,
    ModalHotelIntroComponent,
    ModalImageMessageComponent,
    ModalModifySearchComponent,
    ModalRoomComponent,
    ModalUniversalBenefitsDetailComponent,
    ModalGalleryComponent,
    ModalUserInactivityComponent,
    ModalWithFullPriceComponent,
    ModalDisneyPurchasePolicyComponent,
  ],
})
export class ModalsHotelsModule {}
